import { Injectable } from '@angular/core';
import { GlobalEventBus, ActionEvents } from '@event-bus';
import { MessagesService, MessageType } from '@ui-messages';
import { __i18n } from '@localisation';

/**
 * Shows Message on a specific event
 */
@Injectable({ providedIn : 'root'})
export class WorkflowMessagesService {
    constructor(private eventBus: GlobalEventBus, private messageService: MessagesService) {
        this.eventBus.on(ActionEvents.passwordChanged, () => {
            this.messageService.addMessage({
                text: __i18n('Your password has been changed.', 'account.changepassword.success.message'),
                type: MessageType.success
            });
        });
    }
}
